import { useCallback } from "react";
import "./TabTitle.scss";

export type TabTitleProps = {
  title: string;
  icon?: string;
  index: number;
  setSelectedTab: (index: number) => void;
  isActive?: boolean;
};

const TabTitle = (props: TabTitleProps) => {
  const handleOnClick = useCallback(() => {
    props.setSelectedTab(props.index);
  }, [props.setSelectedTab, props.index]);

  const classes = `tab-title${props.isActive ? ` active` : ``}`;

  return (
    <div className={classes} onClick={handleOnClick}>
      {props.icon && (
        <div className="icon">
          <i className={props.icon}></i>
        </div>
      )}
      <div className="title">{props.title}</div>
    </div>
  );
};

export default TabTitle;
